import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { closeResourceModal } from 'store/reducers/global/global-reducer';
import { setIsResourceFullscreenOpen } from 'store/reducers/navbar-reducer';

export function useResourceModalNavigation() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) return;

    previousPathname.current = pathname;
    dispatch(closeResourceModal({}));
    dispatch(setIsResourceFullscreenOpen(false));
  }, [dispatch, pathname]);
}

export default function ResourceModalNavigationHandler() {
  useResourceModalNavigation();

  return null;
}
